/**
 * Function that creates a link and downloads the file.
 * @param url => URL of the file to be downloaded.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function downloadLink(url: string): void {
  const anchor = document.createElement('a');
  anchor.setAttribute('href', /^http/.test(url) ? url : `https://${url}`);
  anchor.setAttribute('download', url.split('/').at(-1));
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}

export default downloadLink;
